let language = {
    STORE_PRODUCT_SETTING_PRICE_CONFIG_BY_REVENUE_HEAD_PRICE_STRATEGY: "价格策略",
    STORE_PRODUCT_SETTING_PRICE_CONFIG_BY_REVENUE_HEAD_REVENUE: "收入",
    STORE_PRODUCT_SETTING_PRICE_CONFIG_BY_REVENUE_FIX: "固定",
    STORE_PRODUCT_SETTING_PRICE_CONFIG_BY_REVENUE_PERCENT: "百分比",
};

export { language };
